import type {
  UtilityBarOffice,
  UtilityBarOfficeHours,
} from "~www/types/utility-bar";

type OfficeHoursProps = {
  office?: UtilityBarOffice;
  hours?: UtilityBarOfficeHours[];
};

function OfficeHours({ office, hours }: OfficeHoursProps) {
  if (!office) {
    return null;
  }

  if (!hours?.length) {
    return (
      <div className="hidden md:inline-block">
        <span className="font-bold">We&apos;re available 24/7</span> • Get in
        touch with us
      </div>
    );
  }

  return (
    <div className="hidden md:inline-block">
      <ul className="flex-1 flex-row flex-wrap justify-end md:flex">
        {hours.map((officeHours, index) => (
          <li id={officeHours.days} key={officeHours.days}>
            <span className="font-bold">{officeHours.days}: </span>
            {officeHours.hours}
            {index < hours.length - 1 && <span className="mx-2">|</span>}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default OfficeHours;
